export function getAuthorInitials(name: string): string {
  if (!name || typeof name !== 'string') return '?';
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
